import { render } from "./yos-checkbox.vue?vue&type=template&id=3fcfa3be"
import script from "./yos-checkbox.vue?vue&type=script&lang=js"
export * from "./yos-checkbox.vue?vue&type=script&lang=js"

import "./yos-checkbox.vue?vue&type=style&index=0&id=3fcfa3be&lang=postcss"
script.render = render

export default script